import { render, staticRenderFns } from "./widget-store.vue?vue&type=template&id=dc5ec89a&scoped=true&"
import script from "./widget-store.vue?vue&type=script&lang=js&"
export * from "./widget-store.vue?vue&type=script&lang=js&"
import style0 from "./widget-store.vue?vue&type=style&index=0&id=dc5ec89a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5ec89a",
  null
  
)

export default component.exports